/*
 * Oversized cozy tree — trunk + layered foliage. Scale-as-identity per CLAUDE.md.
 */

import { Container, Graphics } from 'pixi.js';

export function createTree(x: number, y: number): Container {
  const root = new Container();
  root.position.set(x, y);

  const g = new Graphics();

  // Trunk.
  g.roundRect(-4, 0, 8, 26, 2).fill(0x5c3d28);
  g.rect(1, 0, 3, 26).fill({ color: 0x000000, alpha: 0.25 });

  // Foliage — three layered green circles.
  g.circle(0, -4, 24).fill(0x2d5a3a);
  g.circle(-8, -10, 16).fill(0x3e6e4f);
  g.circle(10, -8, 14).fill(0x3e6e4f);
  g.circle(-6, -14, 8).fill(0x5a8a5a);
  g.circle(8, -12, 6).fill(0x5a8a5a);

  root.addChild(g);
  return root;
}
